import React, { Component }from 'react';
import styled from 'styled-components'
import { Button } from 'advenio-components'

const Check = styled.img`
    width: 12px;
    height: 12px;
    margin-right: 6px;
`
const DropdownContainer = styled.div`
    position: relative;
`
const DropdownMenu = styled.div`
    position: absolute;
    right: 0;
    left: auto;
    top: 100%;
    z-index: 1000;
    float: left;
    min-width: 10rem;
    padding: .5rem 0;
    margin: .125rem 0 0;
    font-size: 14px;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border-radius: .25rem;
    box-shadow: 0 1px 8px rgba(0,0,0,.2);
`

const DropdownItem = styled.div`
    cursor: ${props => props.disabled ? 'auto' : 'pointer'};
    display: block;
    width: 100%;
    padding: .5rem 1.5rem;
    clear: both;
    font-weight: 400;
    color: ${props => props.disabled ? '#637390' : '#212529'};
    text-align: inherit;
    white-space: nowrap;
    background-color: ${props => props.active ? '#ebebeb' : 'transparent'};
    border: 0;
    padding-left: ${props => props.active ? '8px' : '1.5rem'};
    &:hover{
        background-color: ${props => props.disabled ? 'transparent' : '#f8f9fa'};
    }
`

export default class Dropdown extends Component {

    constructor(props) {
        super(props)

        this.state = {
            open: false,
            optionSelected: null
        }
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside = event => {
        if (this.container && !this.container.contains(event.target)) {
            this.setState({open: false});
        }
    };

    handleClose = option => event => {
        const optSelected = this.state.optionSelected === option.value ? null : option.value;
        this.setState({open: false, optionSelected: optSelected})
        this.props.onClick(optSelected)
    }

    handleClick = () => {
        this.setState(prevState =>{
            return{
                 ...prevState,
                 open : !prevState.open
            }
        });
    }

    render(){
        return  (
            <DropdownContainer  innerRef={(el) => this.container = el}>
                <Button  transparent small id="1" onClick={this.handleClick} textColor="#3E72D7" disabled={this.props.disabled}>
                    <span>Mostrar solo ...</span>
                </Button>
                <DropdownMenu hidden={!this.state.open}>
                    {
                        this.props.options.length ?
                            this.props.options.map(option =>
                                <DropdownItem key={option.value} active={option.value === this.state.optionSelected} onClick={this.handleClose(option)}>
                                    {option.value === this.state.optionSelected && <Check src="/assets/blue_checkmark.svg"/>}
                                    <span>
                                        {option.label}
                                    </span>
                                </DropdownItem> 
                            )
                        :
                            <DropdownItem key="0" disabled>
                                No hay salas
                            </DropdownItem> 
                    }
                </DropdownMenu>
            </DropdownContainer>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Containers/VideoGenerator/components/Dropdown/Dropdown.jsx